export default "__VITE_ASSET__MzlciQsO__"